import { AppMetadataHandler } from './../../../BaseFramework/configs/app-metadata.handler';
import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { environment } from 'environments/environment';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { ValidationUtilService, ApiRequestService, InteractService } from 'app'

@Component({
  selector: 'app-policy-search',
  templateUrl: './policy-search.component.html',
  styleUrls: ['./policy-search.component.scss']
})
export class PolicySearchComponent implements OnInit {

  constructor(
    private viewContainerRef: ViewContainerRef,
    private apiRequestService: ApiRequestService,
    private validationUtilService: ValidationUtilService,
    public appMetadataHandler: AppMetadataHandler,
    private fb: FormBuilder,
    private interactService:InteractService
  ) { }

  //Declaraions
  policySearchCriteriaForm: FormGroup
  POLICYSEARCHCRITERIAFORMNAME = "policySearchCriteriaForm"
  //defaultSearchURL = "claim/misc/searchPolicy"
  // defaultSearchURL = "interface/ods/policy/search"

  defaultSearchURL:any;
  
  currentPage: any = 0;
  itemsPerPage: any = 20;
  searchObservable
  public policyDataSet = []

  //TODO Added for AOT
  attemptToSubmit(){}

  ngOnInit() {
    var consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cGeneric Policy Search : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log("%c<app-policy-search'></app-policy-search'>, has been used. ", consoleStyle)
      console.log("%cYou can override following attributes.", consoleStyle)
      console.log("%cExample , <app-policy-search></app-policy-search'>", consoleStyle)
      console.groupEnd();
    }
    this.initializePolicySearchForm()
  }

  /**
   * ComponentSpecific Inputs, Outputs and Functions
   *  
   */
  @Output() componentOutput = new EventEmitter<any>();
  @Input() title: string = "No Data";
  @Input() list: Array<any>
  @Input() searchURI : any

  EmitComponentOutput(data) {
    this.componentOutput.emit(data)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }

  inputValidation() {

  }


  /* Search by Customer or Policy */
  searchCustOrPolicyLoading: boolean = false;
  searchCustOrPolicyChanged() {
    this.searchCustOrPolicyLoading = true;
    this.showCustomerPolicies = false;
    setTimeout(() => { this.searchCustOrPolicyLoading = false }, 1200);
  }

  modSearchCustOrPolicy: boolean = false;

  showCustomerPolicies: boolean = false;
  showCustomerPoliciesName: string = '';
  viewAddCustomersPolicies(namePassed) {
    this.showCustomerPolicies = true;
    this.showCustomerPoliciesName = namePassed;
  }

  modSearchCustomer: boolean = false;

  /* Variables */
  searchPolicy() {

    var formObject = {
      firstName: this.policySearchCriteriaForm.get('firstName').value,
      lastName: this.policySearchCriteriaForm.get('lastName').value,
      proposalNum: this.policySearchCriteriaForm.get('proposalNum').value,
      policyCommencementDt: this.policySearchCriteriaForm.get('policyCommencementDt').value
    }

    var payload = this.convertToSearchRequestPayload(formObject)

    if (this.searchObservable != null)
      this.searchObservable.unsubscribe();
      var url = ''
      if(this.searchURI != null){
        url = this.searchURI
      }
      else{
        url = this.defaultSearchURL
      }
    this.searchObservable = this.apiRequestService.postCallWithAPIMapper(url, payload).subscribe(data => {
      console.log(data.results)
      this.policyDataSet = data.results;

    });

    console.log(payload)
  }

  convertToSearchRequestPayload(formObject) {
    console.log(formObject)
    var payload = {}
    payload["page"] = this.currentPage
    payload["size"] = this.itemsPerPage || 10
    payload["searchCriteriaList"] = []

    var attributes = JSON.parse(JSON.stringify(Object.keys(formObject)));

    attributes.forEach(key => {
      var criteriaItem = {}
      criteriaItem["paramName"] = key
      criteriaItem["paramValue"] = formObject[key];
      payload["searchCriteriaList"].push(criteriaItem)
    });

    return payload
  }

  initializePolicySearchForm() {
    this.policySearchCriteriaForm = this.fb.group({
      firstName: this.validationUtilService.setValidationsForFormControl('firstName', this.POLICYSEARCHCRITERIAFORMNAME),
      lastName: this.validationUtilService.setValidationsForFormControl('lastName', this.POLICYSEARCHCRITERIAFORMNAME),
      proposalNum: this.validationUtilService.setValidationsForFormControl('proposalNum', this.POLICYSEARCHCRITERIAFORMNAME),
      policyCommencementDt: this.validationUtilService.setValidationsForFormControl('policyCommencementDt', this.POLICYSEARCHCRITERIAFORMNAME)

    });

    if(this.appMetadataHandler.featureFlags.enableInterfaceEndpoints)
    this.defaultSearchURL = "interface/ods/policy/search"
    else
    this.defaultSearchURL = "claim/misc/searchPolicy"
    
  }
  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format(this.appMetadataHandler.GLOBAL_DATE_FORMAT_MOMENT);
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  getSelectedPolicies() {
    return this.policyDataSet.filter(d => d.selected)
  }

  emitSelectedPolicies(){
    let selectedPolicies = this.getSelectedPolicies();
    // this.EmitComponentOutput(selectedPolicies)
    this.interactService.sendSelectedPolicyToPolicyList(selectedPolicies)
    
  }
}
